import { Head } from "@inertiajs/react";
import pageTitle from "../../utils/pageTitle";

export default function () {
  return (
    <>
      <Head title={pageTitle("Политика обработки персональных данных ")} />
      <div className="container mx-auto p-4">
        <div className="prose max-w-none">
          <h1>
            Политика обработки персональных данных ИП Домнин Павел Павлович
          </h1>
          <h2 id="общие-положения">1. Общие положения</h2>
          <p>
            1.1. Политика Общества с ограниченной ответственностью ИП Домнин
            Павел Павлович (ИП Домнин Павел Павлович (Далее по тексту –
            «Оператор») в отношении обработки персональных данных (далее -
            Политика) разработана в целях обеспечения защиты прав и свобод
            субъекта персональных данных при обработке его персональных данных,
            в том числе защиты прав на неприкосновенность частной жизни, личную
            и семейную тайну.
          </p>
          <p>1.2. Основные понятия, используемые в Политике:</p>
          <p>
            1.2.1. Персональные данные - любая информация, относящаяся к прямо
            или косвенно определенному или определяемому физическому лицу
            (субъекту персональных данных);
          </p>
          <p>
            1.2.2. Обработка персональных данных - любое действие (операция) или
            совокупность действий (операций) с персональными данными,
            совершаемых с использованием средств автоматизации или без их
            использования. Обработка персональных данных включает в себя в том
            числе:
          </p>
          <ul>
            <li>
              <p>сбор;</p>
            </li>
            <li>
              <p>запись;</p>
            </li>
            <li>
              <p>систематизацию;</p>
            </li>
            <li>
              <p>накопление;</p>
            </li>
            <li>
              <p>хранение;</p>
            </li>
            <li>
              <p>уточнение (обновление, изменение);</p>
            </li>
            <li>
              <p>извлечение;</p>
            </li>
            <li>
              <p>использование;</p>
            </li>
            <li>
              <p>передачу (распространение, предоставление, доступ);</p>
            </li>
            <li>
              <p>обезличивание;</p>
            </li>
            <li>
              <p>блокирование;</p>
            </li>
            <li>
              <p>удаление;</p>
            </li>
            <li>
              <p>уничтожение.</p>
            </li>
          </ul>
          <p>
            1.2.3. Автоматизированная обработка персональных данных - обработка
            персональных данных с помощью средств вычислительной техники;
          </p>
          <p>
            1.2.4. Распространение персональных данных - действия, направленные
            на раскрытие персональных данных неопределенному кругу лиц;
          </p>
          <p>
            1.2.5. Предоставление персональных данных - действия, направленные
            на раскрытие персональных данных определенному лицу или
            определенному кругу лиц;
          </p>
          <p>
            1.2.6. Блокирование персональных данных - временное прекращение
            обработки персональных данных (за исключением случаев, если
            обработка необходима для уточнения персональных данных);
          </p>
          <p>
            1.2.7. Уничтожение персональных данных - действия, в результате
            которых становится невозможным восстановить содержание персональных
            данных в информационной системе персональных данных и (или) в
            результате которых уничтожаются материальные носители персональных
            данных;
          </p>
          <p>
            1.2.8. Обезличивание персональных данных - действия, в результате
            которых становится невозможным без использования дополнительной
            информации определить принадлежность персональных данных конкретному
            субъекту персональных данных;
          </p>
          <p>
            1.2.9. Оператор персональных данных (оператор) - государственный
            орган, муниципальный орган, юридическое или физическое лицо,
            самостоятельно или совместно с другими лицами организующие и (или)
            осуществляющие обработку персональных данных, а также определяющие
            цели обработки персональных данных, состав персональных данных,
            подлежащих обработке, действия (операции), совершаемые с
            персональными данными.
          </p>
          <p>
            1.3. Оператор, получивший доступ к персональным данным, обязан
            соблюдать конфиденциальность персональных данных - не раскрывать
            третьим лицам и не распространять персональные данные без согласия
            субъекта персональных данных, если иное не предусмотрено федеральным
            законом{" "}
            <a
              href="https://internet.garant.ru/%23/document/12148567/entry/7"
              target="_blank"
            >
              https://internet.garant.ru/%23/document/12148567/entry/7
            </a>
          </p>
          <p>
            1.4. Субъект персональных данных имеет право на получение
            информации, касающейся обработки его персональных данных, в том
            числе содержащей:
          </p>
          <ol type="1">
            <li>
              <p>
                подтверждение факта обработки персональных данных оператором;
              </p>
            </li>
            <li>
              <p>правовые основания и цели обработки персональных данных;</p>
            </li>
            <li>
              <p>
                цели и применяемые оператором способы обработки персональных
                данных;
              </p>
            </li>
            <li>
              <p>
                наименование и место нахождения оператора, сведения о лицах (за
                исключением работников оператора), которые имеют доступ к
                персональным данным или которым могут быть раскрыты персональные
                данные на основании договора с оператором или на основании
                федерального закона{" "}
                <a
                  href="https://internet.garant.ru/%23/document/12148567/entry/0"
                  target="_blank"
                >
                  https://internet.garant.ru/%23/document/12148567/entry/0
                </a>
                ;
              </p>
            </li>
            <li>
              <p>
                обрабатываемые персональные данные, относящиеся к
                соответствующему субъекту персональных данных, источник их
                получения, если иной порядок представления таких данных не
                предусмотрен федеральным законом{" "}
                <a
                  href="https://internet.garant.ru/%23/document/12148567/entry/0"
                  target="_blank"
                >
                  https://internet.garant.ru/%23/document/12148567/entry/0
                </a>
                ;
              </p>
            </li>
            <li>
              <p>
                сроки обработки персональных данных, в том числе сроки их
                хранения;
              </p>
            </li>
            <li>
              <p>
                порядок осуществления субъектом персональных данных прав,
                предусмотренных Федеральным законом{" "}
                <a
                  href="https://internet.garant.ru/%23/document/12148567/entry/300"
                  target="_blank"
                >
                  https://internet.garant.ru/%23/document/12148567/entry/300
                </a>
                ;
              </p>
            </li>
            <li>
              <p>
                информацию об осуществленной или о предполагаемой трансграничной
                передаче данных;
              </p>
            </li>
            <li>
              <p>
                наименование или фамилию, имя, отчество и адрес лица,
                осуществляющего обработку персональных данных по поручению
                оператора, если обработка поручена или будет поручена такому
                лицу;
              </p>
            </li>
          </ol>
          <p>
            9.1) информацию о способах исполнения оператором обязанностей,
            установленных статьей 18.1 Федерального закона;
          </p>
          <ol start="10" type="1">
            <li>
              иные сведения, предусмотренные Федеральным законом “О персональных
              данных” или другими федеральными законами.
            </li>
          </ol>
          <p>
            1.5. Субъект персональных данных вправе требовать от оператора
            уточнения его персональных данных, их блокирования или уничтожения в
            случае, если персональные данные являются неполными, устаревшими,
            неточными, незаконно полученными или не являются необходимыми для
            заявленной цели обработки, а также принимать предусмотренные законом
            меры по защите своих прав.
          </p>
          <p>
            1.6. Субъект персональных данных имеет право на защиту своих прав и
            законных интересов, в том числе на возмещение убытков и (или)
            компенсацию морального вреда в судебном порядке.
          </p>
          <p>1.7. Оператор персональных данных вправе:</p>
          <ul>
            <li>
              <p>отстаивать свои интересы в суде;</p>
            </li>
            <li>
              <p>
                предоставлять персональные данные субъектов третьим лицам, если
                это предусмотрено действующим законодательством (налоговые,
                правоохранительные органы и др.);
              </p>
            </li>
            <li>
              <p>
                отказывать в предоставлении персональных данных в случаях,
                предусмотренных законодательством;
              </p>
            </li>
            <li>
              <p>
                использовать персональные данные субъекта без его согласия в
                случаях, предусмотренных законодательством.
              </p>
            </li>
          </ul>
          <p>
            1.8. При сборе персональных данных оператор обязан предоставить
            субъекту персональных данных по его просьбе информацию,
            предусмотренную частью 7 статьи 14 Федерального закона “О
            персональных данных”.
          </p>
          <p>
            1.9. При сборе персональных данных, в том числе посредством
            информационно- телекоммуникационной сети “Интернет”, оператор обязан
            обеспечить запись, систематизацию, накопление, хранение, уточнение
            (обновление, изменение), извлечение персональных данных граждан
            Российской Федерации с использованием баз данных, находящихся на
            территории Российской Федерации, за исключением случаев, указанных в
            пунктах 2, 3, 4, 8 части 1 статьи 6 Федерального закона “О
            персональных данных”.
          </p>
          <h2 id="цели-сбора-персональных-данных">
            2. Цели сбора персональных данных
          </h2>
          <p>
            2.1. Обработка персональных данных ограничивается достижением
            конкретных, заранее определенных и законных целей. Не допускается
            обработка персональных данных, несовместимая с целями сбора
            персональных данных.
          </p>
          <p>
            2.2. Цели обработки персональных данных происходят в том числе из
            анализа правовых актов, регламентирующих деятельность оператора,
            целей фактически осуществляемой оператором деятельности, а также
            деятельности, которая предусмотрена учредительными документами
            оператора, и конкретных бизнес-процессов оператора в конкретных
            информационных системах персональных данных (по структурным
            подразделениям оператора и их процедурам в отношении определенных
            категорий субъектов персональных данных).
          </p>
          <p>2.3. К целям обработки персональных данных оператора относятся:</p>
          <ul>
            <li>
              <p>
                заключение, исполнение и прекращение гражданско-правовых
                договоров;
              </p>
            </li>
            <li>
              <p>
                организация кадрового учета организации, обеспечение соблюдения
                законов, заключение и исполнение обязательств по трудовым и
                гражданско-правовым договорам;
              </p>
            </li>
            <li>
              <p>
                ведение кадрового делопроизводства, содействие работникам в
                трудоустройстве, обучении и продвижении по службе, пользовании
                льготами;
              </p>
            </li>
            <li>
              <p>
                исполнение требований налогового законодательства по вопросам
                исчисления и уплаты налога на доходы физических лиц, взносов во
                внебюджетные фонды и страховых взносов во внебюджетные фонды,
                пенсионного законодательства при формировании и передаче в ПФР
                персонифицированных данных о каждом получателе доходов, которые
                учитываются при начислении взносов на обязательное пенсионное
                страхование;
              </p>
            </li>
            <li>
              <p>
                заполнение первичной статистической документации в соответствии
                с трудовым, налоговым законодательством и иными федеральными
                законами.
              </p>
            </li>
          </ul>
          <h2 id="правовые-основания-обработки-персональных-данных">
            3. Правовые основания обработки персональных данных
          </h2>
          <p>
            3.1. Правовым основанием обработки персональных данных являются:
          </p>
          <ul>
            <li>
              <p>
                совокупность правовых актов, во исполнение которых и в
                соответствии с которыми оператор осуществляет обработку
                персональных данных: Конституция Российской Федерации; статьи
                86-90 Трудового кодекса Российской Федерации, федеральные законы
                и принятые на их основе нормативные правовые акты, регулирующие
                отношения, связанные с деятельностью оператора;
              </p>
            </li>
            <li>
              <p>уставные документы оператора;</p>
            </li>
            <li>
              <p>
                договоры, заключаемые между оператором и субъектом персональных
                данных;
              </p>
            </li>
            <li>
              <p>
                согласие на обработку персональных данных (в случаях, прямо не
                предусмотренных законодательством Российской Федерации, но
                соответствующих полномочиям оператора).
              </p>
            </li>
          </ul>
          <h2 id="объем-и-категории-обрабатываемых-персональных-данных-категории-субъектов-персональных-данных">
            4. Объем и категории обрабатываемых персональных данных, категории
            субъектов персональных данных
          </h2>
          <p>
            4.1. Содержание и объем обрабатываемых персональных данных
            соответствуют заявленным целям обработки. Обрабатываемые
            персональные данные не должны быть избыточными по отношению к
            заявленным целям их обработки.
          </p>
          <p>
            4.2. Обработка персональных данных допускается в следующих случаях:
          </p>
          <ul>
            <li>
              <p>
                обработка персональных данных осуществляется с согласия субъекта
                персональных данных на обработку его персональных данных;
              </p>
            </li>
            <li>
              <p>
                обработка персональных данных необходима для исполнения
                договора, стороной которого либо выгодоприобретателем или
                поручителем, по которому является субъект персональных данных, а
                также для заключения договора по инициативе субъекта
                персональных данных или договора, по которому субъект
                персональных данных будет являться выгодоприобретателем или
                поручителем;
              </p>
            </li>
            <li>
              <p>
                обработка персональных данных необходима для защиты жизни,
                здоровья или иных жизненно важных интересов субъекта
                персональных данных, если получение согласия субъекта
                персональных данных невозможно;
              </p>
            </li>
            <li>
              <p>
                обработка персональных данных необходима для осуществления прав
                и законных интересов оператора или третьих лиц, в том числе в
                случаях, предусмотренных Федеральным законом “О защите прав и
                законных интересов физических лиц при осуществлении деятельности
                по возврату просроченной задолженности и о внесении изменений в
                Федеральный закон”О микрофинансовой деятельности и
                микрофинансовых организациях”, либо для достижения общественно
                значимых целей при условии, что при этом не нарушаются права и
                свободы субъекта персональных данных;
              </p>
            </li>
            <li>
              <p>
                обработка персональных данных необходима для осуществления
                профессиональной деятельности журналиста и (или) законной
                деятельности средства массовой информации либо научной,
                литературной или иной творческой деятельности при условии, что
                при этом не нарушаются права и законные интересы субъекта
                персональных данных;
              </p>
            </li>
            <li>
              <p>
                обработка персональных данных осуществляется в статистических
                или иных исследовательских целях, за исключением целей,
                указанных в статье 15 Федерального закона “О персональных
                данных”, при условии обязательного обезличивания персональных
                данных;
              </p>
            </li>
            <li>
              <p>
                осуществляется обработка персональных данных, доступ
                неограниченного круга лиц к которым предоставлен субъектом
                персональных данных либо по его просьбе (далее - персональные
                данные, сделанные общедоступными субъектом персональных данных);
              </p>
            </li>
            <li>
              <p>
                осуществляется обработка персональных данных, подлежащих
                опубликованию или обязательному раскрытию в соответствии с
                федеральным законом;
              </p>
            </li>
          </ul>
          <p>4.3. К категориям субъектов персональных данных относятся:</p>
          <p>
            4.3.1. Работники оператора, бывшие работники, кандидаты на замещение
            вакантных должностей, а также родственники работников.
          </p>
          <p>
            В данной категории субъектов оператором обрабатываются персональные
            данные в связи с реализацией трудовых отношений:
          </p>
          <ul>
            <li>
              <p>фамилия, имя, отчество;</p>
            </li>
            <li>
              <p>пол;</p>
            </li>
            <li>
              <p>гражданство;</p>
            </li>
            <li>
              <p>национальность;</p>
            </li>
            <li>
              <p>
                дата (число, месяц, год) и место рождения (страна, республика,
                край, область, район, город, поселок, деревня, иной населенный
                пункт);
              </p>
            </li>
            <li>
              <p>
                адрес места проживания (почтовый индекс, страна, республика,
                край, область, район, город, поселок, деревня, иной населенный
                пункт, улица, дом, корпус, квартира);
              </p>
            </li>
            <li>
              <p>
                сведения о регистрации по месту жительства или пребывания
                (почтовый индекс, страна, республика, край, область, район,
                город, поселок, деревня, иной населенный пункт, улица, дом,
                корпус, квартира);
              </p>
            </li>
            <li>
              <p>
                номера телефонов (домашний, мобильный, рабочий), адрес
                электронной почты;
              </p>
            </li>
            <li>
              <p>замещаемая должность;</p>
            </li>
            <li>
              <p>
                сведения о трудовой деятельности (наименования организаций
                (органов) и занимаемых должностей, продолжительность работы
                (службы) в этих организациях (органах));
              </p>
            </li>
            <li>
              <p>
                иденентификационный номер налогоплательщика (дата (число, месяц,
                год) и место постановки на учет, дата (число, месяц, год) выдачи
                свидетельства);
              </p>
            </li>
            <li>
              <p>
                данные документа, подтверждающего регистрацию в системе
                индивидуального (персонифицированного) учета, в том числе в
                форме электронного документа;
              </p>
            </li>
            <li>
              <p>данные полиса обязательного медицинского страхования;</p>
            </li>
            <li>
              <p>
                данные паспорта или иного удостоверяющего личность документа;
              </p>
            </li>
            <li>
              <p>
                данные паспорта, удостоверяющего личность гражданина Российской
                Федерации за пределами территории Российской Федерации;
              </p>
            </li>
            <li>
              <p>данные трудовой книжки, вкладыша в трудовую книжку;</p>
            </li>
            <li>
              <p>
                сведения о воинском учете (серия, номер, дата (число, месяц,
                год) выдачи, наименование органа, выдавшего военный билет,
                военно-учетная специальность, воинское звание, данные о
                принятии/снятии на (с) учет(а), о прохождении военной службы, о
                пребывании в запасе, о медицинском освидетельствовании и
                прививках);
              </p>
            </li>
            <li>
              <p>
                сведения об образовании (наименование образовательной
                организации, дата (число, месяц, год) окончания, специальность и
                квалификация, ученая степень, звание, реквизиты документа об
                образовании и о квалификации);
              </p>
            </li>
            <li>
              <p>
                сведения о получении дополнительного профессионального
                образования (дата (число, месяц, год), место, программа,
                реквизиты документов, выданных по результатам);
              </p>
            </li>
            <li>
              <p>
                сведения о владении иностранными языками (иностранный язык,
                уровень владения);
              </p>
            </li>
            <li>
              <p>
                сведения о судимости (наличие (отсутствие) судимости, дата
                (число, месяц, год) привлечения к уголовной ответственности
                (снятия или погашения судимости), статья);
              </p>
            </li>
            <li>
              <p>
                сведения о дееспособности (реквизиты документа, устанавливающие
                опеку (попечительство), основания ограничения в дееспособности,
                реквизиты решения суда);
              </p>
            </li>
            <li>
              <p>
                сведения об участии в управлении хозяйствующим субъектом (за
                исключением жилищного, жилищно-строительного, гаражного
                кооперативов, садоводческого, огороднического, дачного
                потребительских кооперативов, товарищества собственников
                недвижимости и профсоюза, зарегистрированного в установленном
                порядке), занятии предпринимательской деятельностью;
              </p>
            </li>
            <li>
              <p>
                сведения, содержащиеся в медицинском заключении установленной
                формы об отсутствии у гражданина заболевания, препятствующего
                поступлению на гражданскую службу или ее прохождению (наличие
                (отсутствие) заболевания, форма заболевания);
              </p>
            </li>
            <li>
              <p>
                сведения о наградах, иных поощрениях и знаках отличия (название
                награды, поощрения, знака отличия, дата (число, месяц, год)
                присвоения, реквизиты документа о награждении или поощрении);
              </p>
            </li>
            <li>
              <p>сведения о дисциплинарных взысканиях;</p>
            </li>
            <li>
              <p>сведения, содержащиеся в материалах служебных проверок;</p>
            </li>
            <li>
              <p>
                сведения о семейном положении (состояние в браке (холост (не
                замужем), женат (замужем), повторно женат (замужем),
                разведен(а), вдовец (вдова), с какого времени в браке, с какого
                времени в разводе, количество браков, состав семьи, реквизиты
                свидетельства о заключении брака);
              </p>
            </li>
            <li>
              <p>
                сведения о близких родственниках, свойственниках (степень
                родства, фамилия, имя, отчество, дата (число, месяц, год) и
                место рождения, место и адрес работы (службы), адрес места
                жительства, сведения о регистрации по месту жительства или
                пребывания);
              </p>
            </li>
            <li>
              <p>
                сведения, содержащиеся в справках о доходах, расходах, об
                имуществе и обязательствах имущественного характера;
              </p>
            </li>
            <li>
              <p>номер расчетного счета;</p>
            </li>
            <li>
              <p>информация об оформленных допусках к государственной тайне;</p>
            </li>
            <li>
              <p>фотографии;</p>
            </li>
          </ul>
          <p>4.3.2. Клиенты и контрагенты оператора (физические лица);</p>
          <p>
            В данной категории субъектов оператором обрабатываются персональные
            данные, полученные оператором в связи с заключением договора,
            стороной которого является субъект персональных данных, и
            используемые оператором исключительно для исполнения указанного
            договора и заключения договоров с субъектом персональных данных:
          </p>
          <ul>
            <li>
              <p>фамилия, имя, отчество;</p>
            </li>
            <li>
              <p>пол;</p>
            </li>
            <li>
              <p>гражданство;</p>
            </li>
            <li>
              <p>
                дата (число, месяц, год) и место рождения (страна, республика,
                край, область, район, город, поселок, деревня, иной населенный
                пункт);
              </p>
            </li>
            <li>
              <p>
                адрес места проживания (почтовый индекс, страна, республика,
                край, область, район, город, поселок, деревня, иной населенный
                пункт, улица, дом, корпус, квартира);
              </p>
            </li>
            <li>
              <p>
                сведения о регистрации по месту жительства или пребывания
                (почтовый индекс, страна, республика, край, область, район,
                город, поселок, деревня, иной населенный пункт, улица, дом,
                корпус, квартира);
              </p>
            </li>
            <li>
              <p>
                номера телефонов (домашний, мобильный, рабочий), адрес
                электронной почты;
              </p>
            </li>
            <li>
              <p>замещаемая должность;</p>
            </li>
            <li>
              <p>
                идентификационный номер налогоплательщика (дата (число, месяц,
                год) и место постановки на учет, дата (число, месяц, год) выдачи
                свидетельства);
              </p>
            </li>
            <li>
              <p>
                данные паспорта или иного удостоверяющего личность документа;
              </p>
            </li>
            <li>
              <p>
                сведения об участии в управлении хозяйствующим субъектом (за
                исключением жилищного, жилищно-строительного, гаражного
                кооперативов, садоводческого, огороднического, дачного
                потребительских кооперативов, товарищества собственников
                недвижимости и профсоюза, зарегистрированного в установленном
                порядке), занятии предпринимательской деятельностью;
              </p>
            </li>
            <li>
              <p>номер расчетного счета;</p>
            </li>
          </ul>
          <p>
            4.3.3. Представители/работники клиентов и контрагентов оператора
            (юридических лиц). В данной категории субъектов оператором
            обрабатываются персональные данные, полученные оператором в связи с
            заключением договора, стороной которого является клиент/контрагент
            (юридическое лицо), и используемые оператором исключительно для
            исполнения указанного договора:
          </p>
          <ul>
            <li>
              <p>фамилия, имя, отчество;</p>
            </li>
            <li>
              <p>пол;</p>
            </li>
            <li>
              <p>
                номера телефонов (домашний, мобильный, рабочий), адрес
                электронной почты;
              </p>
            </li>
            <li>
              <p>замещаемая должность;</p>
            </li>
            <li>
              <p>
                данные паспорта или иного удостоверяющего личность документа;
              </p>
            </li>
            <li>
              <p>
                сведения об участии в управлении хозяйствующим субъектом (за
                исключением жилищного, жилищно-строительного, гаражного
                кооперативов, садоводческого, огороднического, дачного
                потребительских кооперативов, товарищества собственников
                недвижимости и профсоюза, зарегистрированного в установленном
                порядке), занятии предпринимательской деятельностью;
              </p>
            </li>
          </ul>
          <p>
            4.4. Обработка специальных категорий персональных данных, касающихся
            расовой, национальной принадлежности, политических взглядов,
            религиозных или философских убеждений, состояния здоровья, интимной
            жизни, допускается:
          </p>
          <ul>
            <li>
              <p>
                в случае, если субъект персональных данных дал согласие в
                письменной форме на обработку своих персональных данных;
              </p>
            </li>
            <li>
              <p>
                в соответствии с законодательством о государственной социальной
                помощи, трудовым законодательством, пенсионным законодательством
                Российской Федерации.
              </p>
            </li>
          </ul>
          <h2 id="порядок-и-условия-обработки-персональных-данных">
            5. Порядок и условия обработки персональных данных
          </h2>
          <p>
            5.1. Оператор осуществляет обработку персональных данных - операции,
            совершаемые с использованием средств автоматизации или без
            использования таких средств с персональными данными, включая сбор,
            запись, систематизацию, накопление, хранение, уточнение (обновление,
            изменение), извлечение, использование, передачу (предоставление,
            доступ), обезличивание, блокирование, удаление, уничтожение
            персональных данных.
          </p>
          <p>
            5.2. Обработка персональных данных осуществляется с соблюдением
            принципов и правил, предусмотренных Федеральным законом “О
            персональных данных”.
          </p>
          <p>
            5.3. Обработка персональных данных оператором ограничивается
            достижением конкретных, заранее определенных и законных целей.
            Обработке подлежат только персональные данные, которые отвечают
            целям их обработки. Содержание и объем обрабатываемых персональных
            данных должны соответствовать заявленным целям обработки.
          </p>
          <p>
            5.4. Хранение персональных данных должно осуществляться в форме,
            позволяющей определить субъекта персональных данных, не дольше, чем
            этого требуют цели обработки персональных данных, если срок хранения
            персональных данных не установлен федеральным законом, договором,
            стороной которого, выгодоприобретателем или поручителем по которому
            является субъект персональных данных. Обрабатываемые персональные
            данные подлежат уничтожению либо обезличиванию по достижении целей
            обработки или в случае утраты необходимости в достижении этих целей,
            если иное не предусмотрено федеральным законом.
          </p>
          <p>
            5.5. При осуществлении хранения персональных данных оператор
            персональных данных обязан использовать базы данных, находящиеся на
            территории Российской Федерации, в соответствии с ч. 5 ст. 18
            Федерального закона “О персональных данных”.
          </p>
          <p>
            Персональные данные при их обработке, осуществляемой без
            использования средств автоматизации, должны обособляться от иной
            информации, в частности путем фиксации их на отдельных материальных
            носителях персональных данных (далее - материальные носители), в
            специальных разделах или на полях форм (бланков). При фиксации
            персональных данных на материальных носителях не допускается
            фиксация на одном материальном носителе персональных данных, цели
            обработки которых заведомо не совместимы. Для обработки различных
            категорий персональных данных, осуществляемой без использования
            средств автоматизации, для каждой категории персональных данных
            должен использоваться отдельный материальный носитель.
          </p>
          <p>
            5.6. Условием прекращения обработки персональных данных может
            являться достижение целей обработки персональных данных, истечение
            срока действия согласия или отзыв согласия субъекта персональных
            данных на обработку его персональных данных, а также выявление
            неправомерной обработки персональных данных.
          </p>
          <p>
            5.7. Оператор вправе поручить обработку персональных данных другому
            лицу на основании заключаемого с этим лицом договора, в том числе
            государственного или муниципального контракта.
          </p>
          <p>
            Лицо, осуществляющее обработку персональных данных по поручению
            оператора, обязано соблюдать принципы и правила обработки
            персональных данных, предусмотренные Федеральным законом “О
            персональных данных”.
          </p>
          <p>
            Кроме того, оператор вправе передавать персональные данные органам
            дознания и следствия, иным уполномоченным органам по основаниям,
            предусмотренным действующим законодательством Российской Федерации.
          </p>
          <p>
            5.8. Оператор и иные лица, получившие доступ к персональным данным,
            обязаны не раскрывать третьим лицам и не распространять персональные
            данные без согласия субъекта персональных данных, если иное не
            предусмотрено федеральным законом.
          </p>
          <p>
            Согласие на обработку персональных данных, разрешенных субъектом
            персональных данных для распространения, оформляется отдельно от
            иных согласий субъекта персональных данных на обработку его
            персональных данных. Оператор обязан обеспечить субъекту
            персональных данных возможность определить перечень персональных
            данных по каждой категории персональных данных, указанной в согласии
            на обработку персональных данных, разрешенных субъектом персональных
            данных для распространения.
          </p>
          <p>
            Передача (распространение, предоставление, доступ) персональных
            данных, разрешенных субъектом персональных данных для
            распространения, должна быть прекращена в любое время по требованию
            субъекта персональных данных. Данное требование должно включать в
            себя фамилию, имя, отчество (при наличии), контактную информацию
            (номер телефона, адрес электронной почты или почтовый адрес)
            субъекта персональных данных, а также перечень персональных данных,
            обработка которых подлежит прекращению. Указанные в данном
            требовании персональные данные могут обрабатываться только
            оператором, которому оно направлено.
          </p>
          <p>
            5.9. Оператор обязан принимать меры, необходимые и достаточные для
            обеспечения выполнения обязанностей, предусмотренных Федеральным
            законом “О персональных данных” и принятыми в соответствии с ним
            нормативными правовыми актами. Состав и перечень мер оператор
            определяет самостоятельно.
          </p>
          <p>
            5.10. Оператор при обработке персональных данных принимает
            необходимые правовые, организационные и технические меры или
            обеспечивает их принятие для защиты персональных данных от
            неправомерного или случайного доступа к ним, уничтожения, изменения,
            блокирования, копирования, предоставления, распространения
            персональных данных, а также от иных неправомерных действий в
            отношении персональных данных.
          </p>
          <h2 id="порядок-и-условия-обработки-биометрических-персональных-данных">
            6. Порядок и условия обработки биометрических персональных данных
          </h2>
          <p>
            6.1. К биометрическим персональным данным относятся сведения,
            которые характеризуют физиологические и биологические особенности
            человека, на основании которых можно установить его личность и
            которые используются оператором для установления личности субъекта
            персональных данных.
          </p>
          <p>
            6.2. Обработка биометрических персональных данных может
            осуществляться только при наличии согласия в письменной форме
            субъекта персональных данных, за исключением случаев, связанных с
            реализацией международных договоров Российской Федерации о
            реадмиссии, в связи с осуществлением правосудия и исполнением
            судебных актов, в связи с проведением обязательной государственной
            дактилоскопической регистрации, а также в случаях, предусмотренных
            законодательством Российской Федерации об обороне, о безопасности, о
            противодействии терроризму, о транспортной безопасности, о
            противодействии коррупции, об оперативно-разыскной деятельности, о
            государственной службе, уголовно-исполнительным законодательством
            Российской Федерации, законодательством Российской Федерации о
            порядке выезда из Российской Федерации и въезда в Российскую
            Федерацию, о гражданстве Российской Федерации.
          </p>
          <p>
            6.3. Обработка биометрических персональных данных осуществляется
            оператором в соответствии с требованиями к защите биометрических
            персональных данных, установленными в соответствии со статьей 19
            Федерального закона “О персональных данных”.
          </p>
          <p>
            6.4. Использование и хранение биометрических персональных данных вне
            информационных систем персональных данных могут осуществляться
            только на таких материальных носителях информации и с применением
            такой технологии ее хранения, которые обеспечивают защиту этих
            данных от неправомерного или случайного доступа к ним, их
            уничтожения, изменения, блокирования, копирования, предоставления,
            распространения.
          </p>
          <p>
            6.5. Под материальным носителем понимается машиночитаемый носитель
            информации (в том числе магнитный и электронный), на котором
            осуществляются запись и хранение сведений, характеризующих
            физиологические особенности человека и на основе которых можно
            установить его личность.
          </p>
          <p>
            6.6. Оператор утверждает порядок передачи материальных носителей
            уполномоченным лицам.
          </p>
          <p>
            6.7. Материальный носитель должен использоваться в течение срока,
            установленного оператором, осуществившим запись биометрических
            персональных данных на материальный носитель, но не более срока
            эксплуатации, установленного изготовителем материального носителя.
          </p>
          <p>6.8. Оператор обязан:</p>
          <ul>
            <li>
              <p>
                осуществлять учет количества экземпляров материальных носителей;
              </p>
            </li>
            <li>
              <p>
                осуществлять присвоение материальному носителю уникального
                идентификационного номера, позволяющего точно определить
                оператора, осуществившего запись биометрических персональных
                данных на материальный носитель.
              </p>
            </li>
          </ul>
          <p>
            6.9. Технологии хранения биометрических персональных данных вне
            информационных систем персональных данных должны обеспечивать:
          </p>
          <ul>
            <li>
              <p>
                доступ к информации, содержащейся на материальном носителе, для
                уполномоченных лиц;
              </p>
            </li>
            <li>
              <p>
                применение средств электронной подписи или иных информационных
                технологий, позволяющих сохранить целостность и неизменность
                биометрических персональных данных, записанных на материальный
                носитель;
              </p>
            </li>
            <li>
              <p>
                проверку наличия письменного согласия субъекта персональных
                данных на обработку его биометрических персональных данных или
                наличия иных оснований обработки персональных данных,
                установленных законодательством Российской Федерации в сфере
                отношений, связанных с обработкой персональных данных.
              </p>
            </li>
          </ul>
          <p>
            6.10. При хранении биометрических персональных данных вне
            информационных систем персональных данных должна обеспечиваться
            регистрация фактов несанкционированной повторной и дополнительной
            записи информации после ее извлечения из информационной системы
            персональных данных.
          </p>
          <h2 id="актуализация-исправление-удаление-и-уничтожение-персональных-данных-ответы-на-запросы-субъектов-на-доступ-к-персональным-данным">
            7. Актуализация, исправление, удаление и уничтожение персональных
            данных, ответы на запросы субъектов на доступ к персональным данным
          </h2>
          <p>
            7.1. Оператор обязан сообщить в порядке, предусмотренном статьей 14
            Федерального закона “О персональных данных”, субъекту персональных
            данных или его представителю информацию о наличии персональных
            данных, относящихся к соответствующему субъекту персональных данных,
            а также предоставить возможность ознакомления с этими персональными
            данными при обращении субъекта персональных данных или его
            представителя либо в течение тридцати дней с даты получения запроса
            субъекта персональных данных или его представителя.
          </p>
          <p>
            7.2. Оператор обязан предоставить безвозмездно субъекту персональных
            данных или его представителю возможность ознакомления с
            персональными данными, относящимися к этому субъекту персональных
            данных. В срок, не превышающий семи рабочих дней со дня
            предоставления субъектом персональных данных или его представителем
            сведений, подтверждающих, что персональные данные являются
            неполными, неточными или неактуальными, оператор обязан внести в них
            необходимые изменения. В срок, не превышающий семи рабочих дней со
            дня представления субъектом персональных данных или его
            представителем сведений, подтверждающих, что такие персональные
            данные являются незаконно полученными или не являются необходимыми
            для заявленной цели обработки, оператор обязан уничтожить такие
            персональные данные. Оператор обязан уведомить субъекта персональных
            данных или его представителя о внесенных изменениях и предпринятых
            мерах и принять разумные меры для уведомления третьих лиц, которым
            персональные данные этого субъекта были переданы.
          </p>
          <p>
            7.3. В случае подтверждения факта неточности персональных данных
            оператор на основании сведений, представленных субъектом
            персональных данных или его представителем либо уполномоченным
            органом по защите прав субъектов персональных данных, или иных
            необходимых документов обязан уточнить персональные данные либо
            обеспечить их уточнение (если обработка персональных данных
            осуществляется другим лицом, действующим по поручению оператора) в
            течение семи рабочих дней со дня представления таких сведений и
            снять блокирование персональных данных.
          </p>
          <p>
            7.4. Оператор обязан прекратить обработку персональных данных или
            обеспечить прекращение обработки персональных данных лицом,
            действующим по поручению оператора:
          </p>
          <ul>
            <li>
              <p>
                в случае выявления неправомерной обработки персональных данных,
                осуществляемой оператором или лицом, действующим по поручению
                оператора, в срок, не превышающий трех рабочих дней с даты этого
                выявления;
              </p>
            </li>
            <li>
              <p>
                в случае отзыва субъектом персональных данных согласия на
                обработку его персональных данных;
              </p>
            </li>
            <li>
              <p>
                в случае достижения цели обработки персональных данных и
                уничтожить персональные данные или обеспечить их уничтожение
                (если обработка персональных данных осуществляется другим лицом,
                действующим по поручению оператора) в срок, не превышающий
                тридцати дней с даты достижения цели обработки персональных
                данных. В случае отсутствия возможности уничтожения персональных
                данных в течение указанного срока оператор осуществляет
                блокирование таких персональных данных или обеспечивает их
                блокирование (если обработка персональных данных осуществляется
                другим лицом, действующим по поручению оператора) и обеспечивает
                уничтожение персональных данных в срок не более чем шесть
                месяцев, если иной срок не установлен федеральными законами.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
